import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isDirty, isValid } from 'redux-form';

import { Main } from 'Containers/';
import { AERIES_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import { AeriesFieldEnum } from 'Common/Constants/SISIntegration';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';

import { AeriesConfigurationStepForm } from './AeriesConfigurationForm';
import * as actions from '../../state/actions';
import * as selectors from '../../state/selectors';

class AeriesConfigurationStepContainer extends Component {
  static stepInfo = {
    icon: 'configure',
    title: 'Configuration',
    description: 'Configure Aeries credentials',
  };

  state = { hasConfigBeenSavedAlready: false };

  componentDidMount() {
    const { getConfiguration } = this.props;
    getConfiguration();
  }

  mainProps = () => {
    const {
      loading,
      goToNextStep,
      stepCompleted,
      isConfigurationDirty,
    } = this.props;
    return {
      toolbox: {
        formName: AERIES_CONFIGURATION_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: loading,
          disabled: loading,
        },
        rightButtons: [
          {
            content: 'Next',
            disabled: loading || !stepCompleted || isConfigurationDirty,
            loading: loading,
            onClick: goToNextStep,
          },
        ],
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps) {
    const {
      setConfigurationSaveSuccessful,
      clearConfigurationErrors,
      getConfiguration,
      isConfigurationDirty,
      isConfigurationValid,
      setStepCompleted,
      saveSuccessful,
      data,
    } = this.props;

    const { hasConfigBeenSavedAlready } = this.state;

    if (
      errorToast(this.props, prevProps, 'getError') ||
      errorToast(this.props, prevProps, 'writeError')
    ) {
      clearConfigurationErrors();
    }

    if (!prevProps.data && data) {
      if (
        data.BaseUrl &&
        data.BaseUrl.length > 0 &&
        data.Certificate &&
        data.Certificate.length > 0
      ) {
        setStepCompleted(true);
        this.setState({ hasConfigBeenSavedAlready: true });
      }
    }

    if (!prevProps.saveSuccessful && saveSuccessful) {
      createToast(
        toastType.success,
        'Success',
        'Configuration Saved Successfully'
      );
      getConfiguration();
      setConfigurationSaveSuccessful(false);
      setStepCompleted(true);
    }
    if (
      isConfigurationValid &&
      !isConfigurationDirty &&
      (prevProps.isConfigurationDirty || !prevProps.isConfigurationValid) &&
      hasConfigBeenSavedAlready
    ) {
      setStepCompleted(true);
    }
  }

  handleSubmit = (formValues) => {
    const { saveConfiguration } = this.props;
    saveConfiguration(formValues);
  };

  render() {
    const { data, loading } = this.props;
    return (
      <Main {...this.mainProps()}>
        <AeriesConfigurationStepForm
          data={data}
          onSubmit={this.handleSubmit}
          loading={loading}
          initialValues={{
            [AeriesFieldEnum.BaseUrl]: data ? data.BaseUrl : '',
            [AeriesFieldEnum.Certificate]: data ? data.Certificate : '',
            [AeriesFieldEnum.Enabled]: data ? data.Enabled : '',
            [AeriesFieldEnum.ImportFrequency]: data ? data.ImportFrequency : 24,
          }}
        />
      </Main>
    );
  }
}

const mapDispatchToProps = { ...actions };

const mapStateToProps = (state) => {
  const configuration = selectors.getConfiguration(state);
  return {
    data: configuration.data,
    getError: configuration.errors.getError,
    writeError: configuration.errors.writeError,
    loading: configuration.loading,
    saveSuccessful: configuration.saveSuccessful,
    isConfigurationDirty: isDirty(AERIES_CONFIGURATION_FORM_NAME)(state),
    isConfigurationValid: isValid(AERIES_CONFIGURATION_FORM_NAME)(state),
  };
};

export const AeriesConfigurationStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(AeriesConfigurationStepContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesConfigurationStep/AeriesConfigurationStep.js